<template>
  <span class="dmh-wrap">
    <b-button size="sm" variant="outline-secondary"
              :title="selfService ? 'How to read my scorecard' : 'How to use the Individual Driver page'"
              aria-label="Help" @click="show_help = true">
      <i class="fa fa-info-circle"></i>
    </b-button>

    <b-modal v-model="show_help" :title="selfService ? 'Reading your scorecard' : 'Using the Individual Driver page'"
             size="lg" ok-only scrollable>
      <div class="dmh-body">
        <h4>What this page is</h4>
        <p v-if="selfService">
          Your own scorecard: the KPIs behind your combined score for the period you have selected,
          and how they compare with the rest of the roster.
        </p>
        <p v-else>
          One driver in full &mdash; every KPI behind their combined score, how each compares with
          the fleet, and anything that has crossed a threshold this period.
        </p>

        <hr/>

        <h4>Combined score</h4>
        <p>
          Not an average. It is a <b>weighted</b> blend of the KPIs below, and the weights are set
          per tenant &mdash; so a fleet that cares most about idling and one that cares most about
          speeding get different scores from identical driving. The tier (Elite / Solid / Fair /
          High Risk) is a band on that score.
        </p>
        <p>
          <b>Insufficient Data</b> is not a bad grade. It means too few miles or bus days in the
          period to score fairly, so the driver sits out of the ranking rather than scoring badly
          on a handful of trips.
        </p>

        <hr/>

        <h4>The KPI tiles</h4>
        <p>
          Grouped so related metrics stay together &mdash; Safety Metrics, Idling &amp; Fuel, DVIR,
          and Dispatch. Each tile is coloured against your tenant&rsquo;s thresholds, so a red tile
          means &ldquo;past the line you set&rdquo;, not &ldquo;worst on the roster&rdquo;. Two
          drivers can both be red and be very differently placed.
        </p>

        <hr/>

        <h4>Comparisons</h4>
        <p>
          The radar puts this driver against the fleet average on the same axes at once. It is for
          <i>shape</i> &mdash; whether someone is evenly strong or carrying one weak habit &mdash;
          rather than for precise values, which the tiles already give you.
        </p>

        <hr/>

        <h4>The date range</h4>
        <p>
          Scores are published in periods of about five days, each one five days after it ends,
          once your telematics provider's review window has closed. The range ends on the latest
          published period, so it never includes days that are still settling: a half-finished
          period would read as a drop in mileage. The <b>1m</b>, <b>3m</b>, <b>6m</b> and
          <b>12m</b> chips count back from there, and the date pickers show exactly the days being
          scored.
        </p>

        <hr v-if="!selfService"/>

        <h4 v-if="!selfService">Getting it out</h4>
        <p v-if="!selfService">
          <b>Download PDF</b> produces this page as a document for a coaching conversation or a
          file, laid out in the same sections and order you see here.
        </p>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: 'driver_manager_individual_help',
  props: {
    // the page doubles as a driver's own "My Scorecard"; the help should not
    // talk to them about other drivers or about exporting a report on someone
    selfService: { type: Boolean, default: false },
  },
  data() {
    return { show_help: false }
  },
}
</script>

<style scoped>
.dmh-body h4 { font-size: 1.05rem; margin-top: 4px; }
.dmh-body p, .dmh-body li { font-size: 0.95rem; }
.dmh-body li { margin-bottom: 6px; }
</style>
